<!--司法拍卖-->
<template>
  <div class="judicial-container">
    <header-index/>
    <div class="judicial-content">
      <div class="judicial-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>司法拍卖</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="judicial-top">
        <p class="judicial-title">查询司法拍卖</p>
        <el-input placeholder="请输入企业名称、组织机构代码" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="getJudicialSaleInfo">
          <el-button type="danger" slot="append" @click="getJudicialSaleInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="judicial-info">
        <div class="judicial-search-menu">
          <span>搜索到<span style="color: #fe273b">{{ tablePage.total }}</span>条司法拍卖</span>
          <div>
            <el-select v-model="region" placeholder="请选择" style="width: 170px;margin-right: 20px" clearable>
              <el-option :label="'全国'" :value="''"/>
              <el-option v-for="item in provincialCode" :label="item.name" :value="item.code"/>
            </el-select>
            <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份不限" style="width: 170px"/>
          </div>
        </div>
        <div class="judicial-list" v-if="judicialInfo.length>0">
          <div v-for="info of judicialInfo" class="judicial-list-item" @click="judicialDetails(info)">
            <p class="judicial-small-title">{{ info.auctionName }}</p>
            <p>
              <span class="judicial-gray">起拍价（元）：</span>
              <span class="judicial-black judicial-120">{{ info.startingPrice || '-'}}</span>
              <span class="judicial-gray">评估价（元）：</span>
              <span class="judicial-black judicial-120">{{ info.estPrice || '-'}}</span>
              <span class="judicial-gray">委托单位：</span>
              <span class="judicial-black judicial-200">{{ info.executionCourt || '-'}}</span>
              <span class="judicial-gray">拍卖时间：</span>
              <span class="judicial-black">{{ info.auctionTime || '-'}}</span>
            </p>
          </div>
        </div>
        <div v-else>
          <el-empty description="暂无内容"/>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <!--司法拍卖详情-->
    <el-dialog title="司法拍卖详情" :visible.sync="dialogVisible">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">公告名称:</td>
          <td class="col-td3">{{ judicialDetail.auctionName || '-'}}</td>
        </tr>
        <tr>
          <td class="col-td1">拍卖标的:</td>
          <td class="col-td3">{{ judicialDetail.auctionObject || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">起拍价:</td>
          <td class="col-td3">{{ judicialDetail.startingPrice+'元' || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">评估价:</td>
          <td class="col-td3">{{ judicialDetail.estPrice+'元' || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">拍卖阶段:</td>
          <td class="col-td3">{{ judicialDetail.auctionStage || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">委托法院:</td>
          <td class="col-td3">{{ judicialDetail.executionCourt || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">拍卖时间:</td>
          <td class="col-td3">{{ judicialDetail.auctionTime || '-' }}</td>
        </tr>
      </table>
      <el-tabs type="card" :stretch="true" style="margin-top: 30px;">
        <el-tab-pane label="竞买公告" name="first" style="width: 100%">
          <div v-html="judicialDetail.auctionAnnouncement" class="overflow-div" v-if="judicialDetail.auctionAnnouncement"/>
          <div class="empty" v-else>
            <el-empty description="暂无竞买公告"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="竞买须知" name="second" style="width: 100%">
          <div v-html="judicialDetail.biddingInstructions" class="overflow-div" v-if="judicialDetail.biddingInstructions"/>
          <div class="empty" v-else>
            <el-empty description="暂无竞买须知"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="标的物介绍" name="third" style="width: 100%">
          <div v-html="judicialDetail.description" class="overflow-div" v-if="judicialDetail.description"/>
          <div class="empty" v-else>
            <el-empty description="暂无标的物介绍"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hangs";
import Home_footer from "@/components/footer/home_footer";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {getJudicialAuctionRegionGroup, getJudicialAuctionByCid,getJudicialAuctionDetails} from '@/api/enterprise_searchApi'

export default {
  name: "judicialSale",
  components: {Home_footer, Hang, HeaderIndex, page},
  data() {
    return {
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      region: '',
      provincialCode: [],
      judicialInfo: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      judicialDetail:{},
      dialogVisible:false,
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getJudicialSaleInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getJudicialSaleInfo();
      }
    },
  },
  methods: {
    /*获取司法拍卖*/
    getJudicialSaleInfo() {
      getJudicialAuctionByCid({
        keyword: this.keyword,
        provinceId: this.region,
        year: this.year,
        page: this.tablePage.currentPage,
        request:'form'
      }).then(res => {
        if (res.code==200){
          this.tablePage.total=parseInt(res.content.total);
          this.judicialInfo=res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getJudicialSaleInfo();
    },
    /*司法拍卖地域分组*/
    getRegion() {
      getJudicialAuctionRegionGroup().then(res => {
        if (res.code == 200) {
          this.provincialCode = res.content;
        }
      })
    },
    /*司法拍卖详情*/
    judicialDetails(info){
      getJudicialAuctionDetails({id: info.id, request: 'form'}).then(res=>{
        if (res.code==200){
          console.log('司法拍卖详情',res.content);
          this.judicialDetail=res.content;
          this.dialogVisible=true;
        }
      })
    }
  },
  mounted() {
    this.getRegion();
    this.getJudicialSaleInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.judicial-container >>> .judicial-content .judicial-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.judicial-container >>> .judicial-content .judicial-top input::-webkit-input-placeholder {
  color: #333333;
}

.judicial-container >>> .judicial-content .judicial-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.judicial-container >>> .judicial-content .judicial-top .el-icon-search {
  font-size: 19px;
}

.judicial-container >>> .judicial-content .judicial-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__inner a,
.judicial-container >>> .judicial-content .judicial-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.judicial-container >>> .judicial-content .judicial-info .judicial-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
</style>
<style scoped lang="scss">
.judicial-container {
  background: #E7E9F5;

  .judicial-content {
    .judicial-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }

    .judicial-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .judicial-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }

    .judicial-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .judicial-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .judicial-list {
        .judicial-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .judicial-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .judicial-gray {
            color: #999999;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .judicial-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .judicial-120 {
            min-width: 120px;
            display: inline-block;
          }

          .judicial-200 {
            min-width: 200px;
            display: inline-block;
          }

          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
  .dialog-table {
    display: grid;
    border-spacing: 0px;
    .col-td1 {
      padding: 5px 30px 5px 0px;
      text-align: right;
      color: #666666;
      width: 65px;
      font-size: 14px;
      border-spacing: 0px;
      font-family: "SourceHanSansCN";
    }
    .col-td3 {
      padding: 10px 0px;
      background: #ffffff;
      text-align: left;
      width: auto;
      border-spacing: 0px;
      font-size: 14px;
      color: #333333;
      font-family: 'SourceHanSansCN';
    }
  }
  .empty{
    height: 200px;
  }
  .overflow-div{
    min-height: 200px;
  }
}
</style>